"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveLocationsListDto = void 0;
const tslib_1 = require("tslib");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_transformer_1 = require("class-transformer");
const common_1 = require("@goparrot/common");
const class_validator_1 = require("class-validator");
const LocationsItemSetListDto_1 = require("./LocationsItemSetListDto");
class RemoveLocationsListDto extends LocationsItemSetListDto_1.LocationsItemSetListDto {
}
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => Boolean }),
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.UPDATE] }),
    (0, class_validator_1.IsBoolean)({ always: true }),
    (0, class_validator_1.IsOptional)({ always: true }),
    tslib_1.__metadata("design:type", Boolean)
], RemoveLocationsListDto.prototype, "deleteLocation", void 0);
exports.RemoveLocationsListDto = RemoveLocationsListDto;
//# sourceMappingURL=RemoveLocationsListDto.js.map